import DOMPurify from "dompurify";

export const allowedHTMLTags = [
  "p",
  "a",
  "strong",
  "em",
  "u",
  "ol",
  "li",
  "ul",
  "blockquote",
  "span",
  "br",
  "div",
];

export const allowedHTMLAttributes = ["style", "target", "rel", "href"];

export const allowedCSSProperties = [
  "color",
  "box-shadow",
  "background-color",
  "font-weight",
  "font-style",
  "text-decoration",
  "text-align",
  "font-size",
  "margin",
  "padding",
];

export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedHTMLTags,
    ALLOWED_ATTR: allowedHTMLAttributes,
  });
};

export const sanitizeCssValue = (value: string): string => {
  const regexp = /^[a-zA-Z0-9_-]*$/g;
  return value.match(regexp)?.join("") ?? "";
};

export const sanitizeColorValue = (value: string): string => {
  const regexp = /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g;
  return value.match(regexp)?.join("") ?? "";
};
